import { gql } from '@apollo/client';

// Query for invoices grouped by vendor
export const INVOICES_BY_VENDOR = gql`
  query InvoicesByVendor($monthYear: String) {
    invoicesByVendor(monthYear: $monthYear) {
      vendor_name
      vendor_id
      vendor_address
      vendor_contact_number
      vendor_contact_name
      vendor_email_id
      vendor_email_id1
      vendor_email_id2
      vendor_email_id3
      vendor_invoice_prefix
      vendor_due_date
      needdetails_withinvoice
      vendor_purchase_order_no
      total_dollar_value
      total_adjustments
      total_kwh_adjusted
      meter_count
      ipp_wind_net_cost
      ipp_solar_net_cost
      comfit_wind_net_cost
      comfit_solar_net_cost
      maxcap_wind_net_cost
      maxcap_solar_net_cost
      subtotal_meter_cost
      net_subtotal_cost
      hst_rate
      hst_amount
      sum_of_hst
      grand_total
      apply_hst
      invoice_status
      approval_status
      meters_total
      meters_approved
      invoice_computed_approval_signature
      invoice_approved
      created_at
      updated_at
      completed_at
      approved_at
      sent_at
      invoice_type
      co_vendor_invoice_id
      is_counterparty_invoice
      primary_vendor_name
      meters {
        meter_computed_id
        meter_id
        meter_number
        location
        meter_type
        meter_read_type
        read_date
        prod_stat_netgen
        post_prod_stat_netgen
        kwh_adjusted
        agc_energy_kwh
        rate
        dollar_value
        prod_stat_cost_original
        adjustments
        running_negative_cost
        adjustment_negative_generation
        kwh_adjustment_comments
        dollar_adjustment_comments
        reason_for_adjustment
        admin_fee_amount
        admin_fee_label
        admin_fee_rate
        forecast_fee_amount
        forecast_fee_label
        counter_party_amount
        counter_party_label
        counter_party_rate
        primary_vendor_share_amount
        primary_vendor_share_label
        prior_period_adjustment_amount
        prior_period_adjustment_label
      }
      misc_charge {
        misc_charge_id
        invoice_id
        ipp_id
        invoice_month
        reason
        amount
        hst_applicable
      }
    }
  }
`;

// Query to check whether the previous month's invoices are still pending approval
export const CHECK_PREVIOUS_MONTH_INVOICES_PENDING = gql`
  query CheckPreviousMonthInvoicesPending($monthYear: String!) {
    checkPreviousMonthInvoicesPending(monthYear: $monthYear) {
      pendingCount
      monthYear
    }
  }
`;

// Query for NSP Core Info (to get HST rate and company info)
export const NSP_CORE_INFO_BY_TYPE = gql`
  query NspCoreInfoByType($entryType: String!) {
    nspCoreInfoByType(entryType: $entryType) {
      nspCoreInfoId
      entryType
      companyName
      address
      city
      province
      postalCode
      faxNumber
      hstRate
      contactName
      contactPhone
      contactFax
      contactEmail
      approverName
      logoUrl
    }
  }
`;

// Mutation for updating invoice status and approval
export const UPDATE_INVOICE_STATUS = gql`
  mutation UpdateInvoiceStatus(
    $ippId: Int!
    $monthYear: String!
    $invoiceStatus: String
    $approvalStatus: String
    $invoiceApproved: Boolean
    $invoiceComputedApprovalSignature: String
  ) {
    updateInvoiceStatus(
      ippId: $ippId
      monthYear: $monthYear
      invoiceStatus: $invoiceStatus
      approvalStatus: $approvalStatus
      invoiceApproved: $invoiceApproved
      invoiceComputedApprovalSignature: $invoiceComputedApprovalSignature
    ) {
      success
      message
      invoice {
        ipp_id
        invoice_month
        invoice_status
        approval_status
        invoice_approved
        invoice_computed_approval_signature
        approved_at
        sent_at
        updated_at
      }
    }
  }
`;

// Mutation for bulk updating invoice statuses
export const UPDATE_INVOICE_STATUS_BULK = gql`
  mutation UpdateInvoiceStatusBulk($updates: [InvoiceUpdateInput!]!) {
    updateInvoiceStatusBulk(updates: $updates) {
      success
      message
      count
    }
  }
`;

export const LOG_NSP_INVOICE_DOWNLOAD = gql`
  mutation LogNspInvoiceDownload($ippId: Int!, $monthYear: String!, $vendorName: String) {
    logNspInvoiceDownload(ippId: $ippId, monthYear: $monthYear, vendorName: $vendorName)
  }
`;

export const LOG_VENDOR_INVOICE_DOWNLOAD = gql`
  mutation LogVendorInvoiceDownload($ippId: Int!, $monthYear: String!, $vendorName: String) {
    logVendorInvoiceDownload(ippId: $ippId, monthYear: $monthYear, vendorName: $vendorName)
  }
`;

export const SAVE_MISC_CHARGE = gql`
  mutation SaveMiscCharge(
    $ippId: Int!
    $invoiceMonth: String!
    $reason: String
    $amount: Float
    $hstApplicable: Boolean
    $clearCharge: Boolean
  ) {
    saveMiscCharge(
      ippId: $ippId
      invoiceMonth: $invoiceMonth
      reason: $reason
      amount: $amount
      hstApplicable: $hstApplicable
      clearCharge: $clearCharge
    ) {
      misc_charge_id
      invoice_id
      ipp_id
      invoice_month
      reason
      amount
      hst_applicable
    }
  }
`;
